import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { HubspotPartnerFieldMapRow } from "@colab/shared";

// GET /api/settings/integrations/hubspot/partner-field-map
export function usePartnerFieldMap() {
  return useQuery<HubspotPartnerFieldMapRow[], ApiClientError>({
    queryKey: queryKeys.settings.hubspotPartnerFieldMap(),
    queryFn: () =>
      apiFetch<HubspotPartnerFieldMapRow[]>(
        "/settings/integrations/hubspot/partner-field-map",
      ),
  });
}
